import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import Button from '../../../UI/Button/Button';
import {exitExpressCheckoutFlow} from '../../../v2/actions/expressCheckoutActions';
import {stepToPage} from '../../../v2/actions/uiActions';
import Translation from '../../../v2/lang/Translation';
import getIsUsingExpressCheckout from '../../../v2/selectors/ExpressSelectors/getIsUsingExpressCheckout';
import Spacing from '../../../v2/style-helper/Spacing';

const useStyles = createUseStyles({
  changeButton: {
    marginLeft: Spacing.double,
  },
});

export function ChangeButton(props) {
  const classes = useStyles();
  
  const handleClick = () => {
    if (props.usingExpressCheckout && props.isPaymentSection) {
      if (props.isSubscriptionFlow) {
        props.exitExpressCheckoutFlow(`ChangeButton__step-${props.step}`);
        props.stepToPage(props.step);
      } else {
        props.exitExpressCheckoutFlow(`ChangeButton__step-${props.step}`, false, true);
      }
    } else {
      props.stepToPage(props.step);
    }
  };
  
  return (
    <div className={classes.changeButton}>
      <Button
        data-test="ChangeButton"
        id={`ChangeButton__step-${props.step}`}
        link
        noResize
        onClick={() => handleClick()}
      >
        <Translation>
          collapsible.btn.change.text
        </Translation>
      </Button>
    </div>
  );
}

ChangeButton.propTypes = {
  stepToPage: PropTypes.func.isRequired,
  exitExpressCheckoutFlow: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  usingExpressCheckout: PropTypes.bool.isRequired,
  isPaymentSection: PropTypes.bool,
  isSubscriptionFlow: PropTypes.bool,
};

const mapStateToProps = (state) => {
  const usingExpressCheckout = getIsUsingExpressCheckout(state);
  return {
    usingExpressCheckout,
    isSubscriptionFlow: usingExpressCheckout && state.start.order.hasAutoRenewSubscriptions,
  };
};

export default connect(mapStateToProps, {stepToPage, exitExpressCheckoutFlow})(ChangeButton);
